/**
 * Escape HTML special characters to prevent injection in generated HTML strings.
 *
 * Use this whenever interpolating user-supplied or dynamic text into an HTML
 * template string (e.g. inside `<title>`, `<h1>`, `<td>`, `<code>` etc.).
 *
 * The replacement order matters: `&` must be first to avoid double-encoding.
 */
export const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
